﻿import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { apiLink } from "../../../constant/api-link";

@Injectable({
  providedIn: "root"
})
export class CompanyEditService {

    constructor(
        private http: HttpClient
    ) { }

    // update grade company
    updateGradeCompanyBackOffice(gradeCompany: number, companySurrkey: number): Observable<boolean> {
        const url = apiLink.updateGradeCompany;
        const params = new HttpParams()
            .set("gradeCompany", gradeCompany.toString())
            .set("companySurrkey", companySurrkey.toString());

        return this.http.get<boolean>(url, { params });
    }
}
